import { ChangeDetectionStrategy, Component, effect, inject, DOCUMENT } from '@angular/core';
import { DomSanitizer, Title } from '@angular/platform-browser';
import { MatIconModule, MatIconRegistry } from '@angular/material/icon';
import { RouterOutlet } from '@angular/router';
import { SessionContextService } from './core/services/session-context.service';

const TENANT_TITLES: Record<string, string> = {
  RPLAZA: 'Real Plaza',
  HPSA:   'Promart',
  TPSA:   'Oechsle',
  PVEA:   'plazaVea',
  AGORA:  'Agora',
};

const TENANT_FAVICONS: Record<string, string> = {
  RPLAZA: 'assets/img/rplaza_favicon_16x16.ico',
  HPSA:   'assets/img/hpsa_favicon_16x16.ico',
  TPSA:   'assets/img/tpsa_favicon_16x16.ico',
  PVEA:   'assets/img/pvea_favicon_16x16.ico',
  AGORA:  'assets/img/agora_favicon_16x16.ico',
};

@Component({
  selector: 'app-root',
  template: '<router-outlet></router-outlet>',
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [RouterOutlet, MatIconModule]
})
export class AppComponent {
  private sessionContextService = inject(SessionContextService);
  private titleService = inject(Title);
  private matIconRegistry = inject(MatIconRegistry);
  private domSanitizer = inject(DomSanitizer);
  private document = inject(DOCUMENT);

  constructor() {
    this.matIconRegistry.addSvgIcon(
      'shipment_1',
      this.domSanitizer.bypassSecurityTrustResourceUrl('../assets/icon/shipment_1.svg')
    );
    this.matIconRegistry.addSvgIcon(
      'rexProduct',
      this.domSanitizer.bypassSecurityTrustResourceUrl('../assets/icon/icon-monitor.svg')
    );
    this.matIconRegistry.addSvgIcon(
      'rexPackage',
      this.domSanitizer.bypassSecurityTrustResourceUrl('../assets/icon/icon-caja-de-entrega.svg')
    );

    effect(() => {
      const tenantId = this.sessionContextService.tenantId();
      if (!tenantId) return;
      const key = tenantId.toUpperCase();
      const appFavicon = this.document.getElementById('appFavicon') as HTMLLinkElement;
      if (TENANT_TITLES[key]) this.titleService.setTitle(TENANT_TITLES[key]);
      if (TENANT_FAVICONS[key] && appFavicon) appFavicon.setAttribute('href', TENANT_FAVICONS[key]);
    });
  }
}
